export enum StorageKeys {
  AddressComplete = 'address_complete',
  AuthToken = 'auth-token',
  BetterLab = 'betterlab',
  Center = 'center',
  Coupon = 'coupon',
  Discount = 'discount',
  EcommerceTrackingCategories = 'ecommerce_tracking_categories',
  Email = 'email',
  ExtraCharges = 'extraCharges',
  Fee = 'fee',
  Free = 'free',
  HasEmail = 'hasEmail',
  HasPartner = 'hasPartner',
  InHomeBookingResult = 'in-home-booking-result',
  InHomeCollection = 'inHomeCollection',
  BaOrder = 'baOrder',
  IsShipped = 'isShipped',
  LabChanged = 'lab_changed',
  Order = 'order',
  OrderTotal = 'orderTotal',
  OrderType = 'order_type',
  OrderUpsells = 'orderUpsells',
  Patient = 'patient',
  PaymentType = 'paymentType',
  ProviderIds = 'provider-ids',
  SecondaryPaymentTransactionId = 'secondary_payment_transaction_id',
  SendSms = 'sendSMS',
  Tests = 'tests',
  TransactionId = 'transaction_id',
  TreatmentType = 'treatmentType',
  UpsellTransactionId = 'upsell_transaction_id',
  UserId = 'user_id',
  ZipCode = 'zip_code',
  ReorderId = 'reorder_id',
  IsIhcPaid = 'is_ihc_paid',
  OrderedTests = 'ordered_tests',
}
